import {isObject} from "./Utils";

export const selfSignupEtcFieldDefs = {
  BIZ_NAME: {
    type: "TEXT"
  },
  WEB_ADDRESS: {
    type: "URL",
  },
  INTENDED_BUDGET: {
    type: "SELECT",
    opts: [
      {
        value: "UNDER_50K",
        label: "Under $50,00",
      },
      {
        value: "50K_100K",
        label: "$50,00 - $100,000",
      },
      {
        value: "100K_250K",
        label: "$100,00 - $250,000",
      },
      {
        value: "250K_500K",
        label: "$250,00 - $500,000",
      },
      {
        value: "OVER_500K",
        label: "Over $500,000",
      }
    ]
  },
  REFERRAL_SOURCE: {
    type: "SELECT",
    opts: [
      {
        value: "ADVERTISEMENT",
        label: "Advertisement"
      },
      {
        value: "FRIEND",
        label: "Friend or Colleague"
      },
      {
        value: "RESELLER",
        label: "Reseller or Partner",
      },
      {
        value: "SEARCH",
        label: "Search Engine (e.g. Google, Bing, etc.)",
      },
      {
        value: "ARTICLE",
        label: "News / Blog / Article",
      },
      {
        value: "SOCIAL_MEDIA",
        label: "Social Media (e.g. LinkedIn, Facebook, X, etc.)",
      },
      {
        value: "DIRECT",
        label: `Contacted by your team`
      },
      {
        value: "CLIENT",
        label: "Existing Client"
      },
    ]
  },
  MESSAGE: {
    type: "TEXTAREA"
  }
}

selfSignupEtcFieldDefs.REFERRAL_SOURCE.opts.sort((a, b) => a.label.localeCompare(b.label));
selfSignupEtcFieldDefs.REFERRAL_SOURCE.opts.push(
  {
    value: "OTHER",
    label: "Other"
  }
)

export function getSelfSignupFieldOptionFromValue(field, value) {
  return selfSignupEtcFieldDefs[field].opts?.find(f => f.value === value)
}

export function getSelfSignupFieldValueFromOption(opt) {
  return opt?.value
}

export function gotoDest(props, data) {
  let dest = "/";
  if (data.dest) {
    dest = data.dest
  }
  else {
    const referrer = getReferrer()
    if (referrer) {
      dest = referrer
    }
    else if (props?.location?.state?.referrer) {
      const {pathname, search, hash} = props.location.state.referrer
      if (pathname) {
        dest = `${pathname}${search}${hash}`
      }
    }
  }
  window.location = dest
}

const REFERRER_KEY = "SOLV_REFERRER"

export function storeReferrer(location) {
  if (location) {
    let value
    if (isObject(location)) {
      const {pathname, search, hash} = location
      value = `${pathname}${search}${hash}`
    }
    else {
      value = location
    }
    sessionStorage.setItem(REFERRER_KEY, value)
  }
}

export function getReferrer() {
  let value = sessionStorage.getItem(REFERRER_KEY)
  if (value) {
    sessionStorage.removeItem(REFERRER_KEY)
  }
  return value
}

export function peekReferrer() {
  return sessionStorage.getItem(REFERRER_KEY)
}

export function removeReferrer() {
  return sessionStorage.removeItem(REFERRER_KEY)
}
